import * as angular from 'angular';

import { ComponentDefinition, Pattern, GroupNameDto, AlarmRowViewModel, Dictionary } from '../../../../models';
import { alarmsSearchCriteria } from '../alarmsSearchCriteria';
import { Paginator } from './paginator';

class AlarmsGlobalTableController implements angular.IComponentController {
    alarms: AlarmRowViewModel[];
    currentAlarms: AlarmRowViewModel[];
    displayChildren: boolean;
    filteredAlarms: AlarmRowViewModel[];
    headings: Dictionary<boolean>;
    paginated: AlarmRowViewModel[];
    paginator: Paginator<AlarmRowViewModel>;
    searchCriteria: Pattern<AlarmRowViewModel>[];
    selectedGroup: GroupNameDto;

    static $inject = [];

    $onInit() {
        this.searchCriteria = alarmsSearchCriteria;
        this.displayChildren = true;
        this.paginator = new Paginator<AlarmRowViewModel>();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['alarms']?.currentValue || changesObj['selectedGroup']?.currentValue)
        {
            this.filter();
        }
    }

    toggleChildren(): void {
        this.displayChildren = !this.displayChildren;
        this.filter();
    }

    onFilter(items: AlarmRowViewModel[]) {
        this.paginated = this.paginator.items(items).paginate();
    }

    more() {
        this.paginated = this.paginator.more();
    }

    private filter() {
        if (this.selectedGroup) {
            const groupName = this.selectedGroup.absoluteName;
            // select alarms in group itself
            const selected = this.alarms
                .filter(a => a.identifier.groupAbsolutePath === groupName);
            if (this.displayChildren) {
                // add the children
                const startOfChildName = this.selectedGroup.absoluteName + '/';
                selected.push(...this.alarms.filter(a => a.identifier.groupAbsolutePath.indexOf(startOfChildName) === 0));
            }
            this.currentAlarms = selected;
        } else {
            this.currentAlarms = this.alarms;
        }
        if (this.currentAlarms && this.currentAlarms.length && this.paginator) {
            // TODO seems wrong should use this.filteredAlarms
            // but maybe we should not call filter at all when isEditMode change...
            this.paginated = this.paginator.items(this.currentAlarms)
                .paginate();
        }
    }
}

export const wtAlarmsGlobalTable: ComponentDefinition = {
    componentId: 'wtAlarmsGlobalTable',
    controller: AlarmsGlobalTableController,
    template: require('./alarmsGlobalTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        alarms: '<',
        changedItems: '=?',
        filteredAlarms: '=',
        headings: '<?',
        isEditMode: '<?',
        paginator: '=?',
        selectedGroup: '<?',
        tableFormController: '=?',
    }
};